export const shadowOpacity = {
  off: 0,
  on: 0.5,
};

export const shadowRadius = {
  off: 0,
  on: 6,
};
